import React, { Component } from 'react';
import { Form, Table, Modal, Button } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { getLogList } from '../../apis/api'
import './index.css'

import SearchForm from './SearchForm';
import SystemList from './components/systemList'

class LogManagement extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      loading: false,
      modelSystem: '',
      systemvisible: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
    }
  }

  componentWillMount() {}

  componentDidMount(){
    // this.getList()
  }

  componentWillUnmount() {
    // 在卸载的时候对所有的操作进行清除
    this.setState = (state, callback) => {
      return;
    };
  }

  getList = () => {
    const form = this.searchFormRef;
    const { pagination } = this.state;
    this.setState({
      loading: true
    })
    form.validateFields((err, values) => {
      if (err) return;
      let params = {
        access_token: sessionStorage.getItem('access_token'),
        model: values.model && values.model.split('=')[0],
        uuid: values && values.uuid ? values.uuid : '',
        oa: values && values.oa ? values.oa : '',
        method: values && values.method ? values.method : '',
        route: values && values.route ? values.route : '',
        start_time: values && values.date ? values.date.map(item => moment(item).valueOf())[0] : '',
        end_time: values && values.date ? values.date.map(item => moment(item).valueOf())[1] : '',
        page: pagination.current,
        page_size: pagination.pageSize,
      }
      
      getLogList({ ...params }).then(res => {
        if(res.code === 0) {
          this.setState({
            loading: false,
            listData: res.content.data,
            modelSystem: values.model,
            pagination: Object.assign(pagination,{
              total: res.content.total
            }),
          })
        } else {
          this.setState({
            listData: [],
            loading: false
          })
        }
      }).catch(err => {
        this.setState({
          loading: false
        })
      })
    })
    
  }

  // 页码改变
  handlePageChange = (page, pageSize) => {
    const { pagination } = this.state;
    this.setState({
      pagination: Object.assign(pagination, {
        current: page
      })
    }, () => {
      this.getList()
    })
  }

  // 每页条数改变
  handlePagesizeChange = (page, pageSize) => {
    const { pagination } = this.state;
    this.setState({
      pagination:{
        ...pagination,
        current: 1, 
        pageSize,
      }
    },() =>{
      this.getList();
    })
  }

  // 重置表单
  resetSearchForm() {
    this.searchFormRef.resetFields()
    const { pagination } = this.state;
    this.setState({
      pagination:{
          ...pagination,
          current: 1, 
          pageSize: 10,
      }
    },() =>{
      this.getList();
    }) 
  }

  // 表单搜索
  formSearch() {
    const { pagination } = this.state;
    this.setState({
      pagination:{
          ...pagination,
          current: 1, 
          pageSize:10,
      }
    },() =>{
      this.getList();
    })
  }

  // 预览请求参数/返回内容
  showParams = (e) => {
    let obj = JSON.parse(e);
    let objectAsString = JSON.stringify(obj, null, 2);
    Modal.info({
      title: '请求参数/返回内容',
      okText: '关闭',
      width: '1000px',
      maskClosable: true,
      content: (
        <div>
          <pre>{objectAsString}</pre>
        </div>
      ),
      onOk() {},
    });
  }

  render() {
    const { loading, listData, pagination, modelSystem, systemvisible } = this.state;
    const columns = [
      {
        title: '序号',
        dataIndex: 'id',
        width:'60px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: 'uuid',
        dataIndex: 'uuid',
        width:'120px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '应用系统',
        dataIndex: 'model',
        width:'80px',
        align:'center',
        render: text => <span>{modelSystem && modelSystem.split('=')[1]}</span>,
      }, {
        title: 'oa账号',
        dataIndex: 'oa',
        width:'120px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '请求方式',
        dataIndex: 'method',
        width:'80px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '操作描述',
        dataIndex: 'describe',
        width:'120px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '请求参数',
        dataIndex: 'params',
        width:'120px',
        align:'center',
        render: text => <code type='link' className='table_content' onClick={() => this.showParams(text)}>{text}</code>,
      }, {
        title: '返回内容',
        dataIndex: 'content',
        width:'120px',
        align:'center',
        render: text => <code type='link' className='table_content' onClick={() => this.showParams(text)}>{text}</code>,
      }, {
        title: '时间',
        dataIndex: 'created_at',
        width:'120px',
        align:'center',
        render: text => (<span>{text ? moment.unix(parseInt(text/1000)).format("YYYY-MM-DD HH:mm:ss") : ''}</span>)
      }, {
        title: '响应时间ms',
        dataIndex: 'time',
        width:'120px',
        align:'center',
        render: text => (<span>{text}</span>)
      }, {
        title: '请求接口',
        dataIndex: 'route',
        width:'120px',
        align:'center',
        render: text => <span>{text}</span>,
      }, 
    ]
    const tableConfig = {
      loading: loading,
      columns: columns,
      pagination,
      dataSource: listData
    }
    return (
      <div className="layout_content_wrapper">
        <SearchForm
          ref={c => this.searchFormRef = c}
          doSearch={() => this.formSearch()}
          reset={() => this.resetSearchForm()}
        />
        <div>
          <Button
            type="primary"  
            onClick={()=>{
              this.setState({
                systemvisible: true
              })
            }}
          >应用系统</Button>
        </div>
        <div className='layout_content_table'>
          <Table
            rowKey={(record, index) => index}
            {...tableConfig}
            scroll={{ x: 1400 }} 
          />
          <span className='data-text'>共{pagination.total}条数据</span>
        </div>
        {
          systemvisible ? 
            <SystemList
              visible={systemvisible}
              handleCancel={() => this.setState({ systemvisible: false })} 
            /> : ''
        }
      </div>
    );
  }
}

const LogManagementForm = Form.create()(LogManagement);
export default LogManagementForm;


// WEBPACK FOOTER //
// ./src/page/LogManagement/index.js